var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Switch as ChakraSwitch } from "@chakra-ui/react";
/**
 * The Switch component is used as an alternative for the checkbox component.
 */
const Switch = forwardRef((props, ref) => {
    const { className, colorScheme, variantColor } = props, rest = __rest(props, ["className", "colorScheme", "variantColor"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    return (React.createElement(ChakraSwitch, Object.assign({ ref: ref }, rest, { colorScheme: scheme, className: className })));
});
Switch.displayName = "Switch";
export default Switch;
//# sourceMappingURL=Switch.js.map